import s from './Header.module.sass'
import React, { FC, memo } from 'react'
import { useRouter } from 'next/navigation'

import { useAppSelector } from '@app/model/store'

import { City } from '@widgets/Common/Header/ui/City'
import { IconLogoRest, IconLogoText } from '@widgets/Common/Header/ui/Logo'
import { UserMenu } from '@widgets/Common/Header/ui/UserMenu'

import { ContainerLong } from '@shared/ui/Layout/Containers/ContainerLong'
import { ErrorBoundary } from '@shared/lib/components/ErrorBoundary'
import { HeaderSkeleton } from '@widgets/Common/Header/index'
import { IconButton } from '@shared/ui/Actions/IconButton'
import { Menu } from '@widgets/Common/Header/ui/Menu'

import IconTickets from '@icons/icon-tickets.svg'
import AfishaOwnerLogo from '@icons/afisha-restaurants-owner-logo.svg'
import { useClientResponsive } from '@shared/lib/hooks/useClientResponsive'
import Link from 'next/link'

const TICKETS_LINK = 'https://www.afisha.ru/w/orderList/a4910f07-c5da-47b1-b0ec-1da5418ae3f2/www.afisha.ru'
import { QuickSearchButton } from '@features/QuickSearch/QuickSearchButton'

const getRestCardLink = (router: any): string | null => {
  const citySlug = router?.query?.city_slug || null
  const restSlug = router?.query?.rest_slug || null
  return citySlug && restSlug ? `/${citySlug}/restaurant/${restSlug}/` : null
}

const Header: FC = () => {
  const { isMobile } = useClientResponsive()
  const router = useRouter()
  const storeCurrentPage = useAppSelector((state) => state.global.currentPage)
  const storeLoaded = useAppSelector((state) => state.global.storeLoaded)
  const storeUserData = useAppSelector((state) => !!state.global.user.data)

  const restCardLink = getRestCardLink(router)
  const isOwnerPage = storeCurrentPage === 'owner_marketing' || storeCurrentPage === 'owner_booking'

  return (
    <ErrorBoundary>
      {storeLoaded ? (
        <ContainerLong
          tag={'header'}
          classNameContent={`${s['header-content']} ${isOwnerPage ? s['header-content--owner'] : ''}`}
          classNameContainer={`${s['header-container']} ${isOwnerPage ? s['header-container--owner'] : ''}`}>
          <>
            {isOwnerPage ? (
              <AfishaOwnerLogo className={s['logo-owner']} />
            ) : (
              <div className={s['logo']}>
                <IconLogoRest />
                <div className={s['logo-column']}>
                  <IconLogoText />
                  <City />
                </div>
              </div>
            )}

            {!isOwnerPage && <Menu />}

            <div className={s.header_additional}>
              {isOwnerPage ? (
                restCardLink &&
                !isMobile && (
                  <a href={restCardLink} className={s['back-button']}>
                    Вернуться на сайт
                  </a>
                )
              ) : (
                <>
                  {!isMobile && <QuickSearchButton />}

                  {storeUserData && (
                    <Link href={TICKETS_LINK} target={'_blank'}>
                      <IconButton data-icon={'IconLike'} icon={IconTickets} sizes='L M' mode='white-border' />
                    </Link>
                  )}
                </>
              )}

              <UserMenu />
            </div>
          </>
        </ContainerLong>
      ) : (
        <HeaderSkeleton />
      )}
    </ErrorBoundary>
  )
}

export default memo(Header)
